module.exports = __webpack_public_path__ + "static/img/forests09.4477174.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/forests09.jpg
// module id = +koW
// module chunks = 0